<main class="c-content">
  <div class="c-content__info">
    <p class="is-title">Equipamento</p>
    <app-card [data]="cardData"></app-card>
  </div>

  <form class="c-content__form" [formGroup]="form" (ngSubmit)="submitForm()">
    <fieldset class="c-content__fieldset">
      <legend class="is-title">Endereço de atendimento</legend>

      <div class="address-filter">
        <label class="c-content__checkbox-label">
          <input
            #addressCheckboxElement
            (change)="handleAddress(addressCheckboxElement.checked)"
            class="input__checkbox"
            type="checkbox"
          />
          <span class="checkbox-label__text">
            Manter endereço cadastrado:
            <span class="address-text">{{
              formPrimeiroPasso.get('site')?.value?.endereco
            }}</span>
          </span>
        </label>
        <button
          type="button"
          class="filter__submit-button"
          (click)="limparEndereco(addressCheckboxElement.checked)"
        >
          Limpar
        </button>
      </div>

      <label for="cep" class="c-content__label">
        <span class="label-text">CEP *</span>
        <input
          class="c-content__input"
          required
          name="cep"
          formControlName="cep"
          (keyup)="onCepKeyUp(f.cep.value)"
          [showMaskTyped]="true"
          mask="00000-000"
          [hiddenInput]="true"
          placeholder="00000-000"
        />
      </label>

      <div class="c-content__double-input-container">
        <label for="logradouro" class="c-content__label">
          <span class="label-text">Logradouro (Rua, Av, etc) *</span>
          <input
            class="c-content__input"
            required
            name="logradouro"
            formControlName="logradouro"
            maxLength="60"
            placeholder="Nome da rua"
          />
        </label>
        <label for="num" class="c-content__label">
          <span class="label-text">Número *</span>
          <input
            class="c-content__input"
            name="num"
            formControlName="num"
            maxLength="9"
            placeholder="Nº"
            inputmode="numeric"
          />
        </label>
      </div>

      <div class="c-content__double-input-container">
        <label for="estado" class="c-content__label">
          <span class="label-text">Estado *</span>
          <select
            #stateSelectElement
            required
            (change)="
              getCities(stateSelectElement.value);
              form.controls.cidade.setValue('')
            "
            class="c-content__input is-select"
            name="estado"
            formControlName="estado"
          >
            <option value="" selected disabled>Selecionar estado</option>
            <option *ngFor="let state of states" value="{{ state.sigla }}">
              {{ state.nome }}
            </option>
          </select>
        </label>
        <label for="cidade" class="c-content__label">
          <span class="label-text">Cidade *</span>
          <select
            required
            class="c-content__input is-select"
            name="cidade"
            formControlName="cidade"
          >
            <option value="" selected disabled>Selecionar cidade</option>
            <option
              *ngFor="let city of cities"
              [value]="city.nome.toUpperCase()"
            >
              {{ city.nome }}
            </option>
          </select>
        </label>
      </div>

      <label for="bairro" class="c-content__label">
        <span class="label-text">Bairro *</span>
        <input
          class="c-content__input"
          name="bairro"
          formControlName="bairro"
          maxLength="30"
          placeholder="Nome do bairro"
        />
      </label>

      <label for="comp" class="c-content__label">
        <span class="label-text">Complemento</span>
        <input
          class="c-content__input"
          name="comp"
          formControlName="comp"
          maxLength="20"
          placeholder="Apto, bloco, etc"
        />
      </label>

      <app-botao-submit class="c-content__submit" [disabled]="form.invalid"
        >Continuar</app-botao-submit
      >
    </fieldset>
  </form>
</main>
